import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import { Hero } from "./components/sections/Hero";
import { Audience } from "./components/sections/Audience";
import { VideoShowcase } from "./components/sections/VideoShowcase";
import { Benefits } from "./components/sections/Benefits";
import { Features } from "./components/sections/Features";
import { Steps } from "./components/sections/Steps";
import { Platforms } from "./components/sections/Platforms";
import { Pricing } from "./components/sections/Pricing";
import { Comparison } from "./components/sections/Comparison";
import { Faq } from "./components/sections/Faq";
import { CtaBanner } from "./components/sections/CtaBanner";

import styles from "./App.module.css";

export function App() {
  return (
    <div className={styles.app}>
      <Header />
      <main>
        <Hero />
        <Audience />
        <VideoShowcase />
        <Benefits />
        <Features />
        <Steps />
        <Platforms />
        <Pricing />
        <Comparison />
        <Faq />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}
